(() => {
  const ROOT_SELECTOR = '[data-hr-policy-owned]';
  const initializedRoots = new WeakSet();

  const initialize = (root) => {
    if (!root || initializedRoots.has(root)) return;
    initializedRoots.add(root);

    const links = [...root.querySelectorAll('[role="link"][tabindex="0"]')];
    const targets = [...root.querySelectorAll('[data-alchemy-url-hashmark]')];
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    links.forEach((link, index) => {
      const target = targets[index];
      if (!target) return;
      link.setAttribute('aria-label', `Jump to ${link.textContent.trim()}`);
      const navigate = () => target.scrollIntoView({ behavior, block: 'start' });
      link.addEventListener('click', navigate);
      link.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        navigate();
      });
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
